import type { FormEvent } from 'react';
import classNames from 'classnames';

import ExternalLink from 'src/components/common/external-link';

import type { CheckboxProps } from './checkbox.props';

import './checkbox.scss';

function Checkbox({
  id,
  className,
  isChecked,
  isDisabled,
  isError,
  isSemiState,
  label,
  linkLabel,
  linkUrl = '#',
  onChange,
}: CheckboxProps) {
  const checkboxClasses = classNames('checkbox', className, {
    checkbox_checked: isChecked,
    checkbox_disabled: isDisabled,
    checkbox_error: isError,
    checkbox_semi: isSemiState,
  });

  const handleChange = (evt: FormEvent<HTMLInputElement>) => onChange(evt.currentTarget.checked);

  return (
    <div className={checkboxClasses}>
      <input
        className="checkbox__input"
        type="checkbox"
        id={id}
        checked={isChecked}
        onChange={handleChange}
        disabled={isDisabled}
      />
      <label className="checkbox__label" htmlFor={id}>
        <span className="checkbox__label-icon">
          <span className="checkbox__label-icon-wrapper" />
        </span>
        <span className="checkbox__label-text-wrapper">
          <span className={classNames(linkLabel && 'checkbox__label-text')}>{label}</span>

          {linkLabel && (
            <>
              {' '}
              <ExternalLink
                className="checkbox__link"
                href={linkUrl}
                tabIndex={isDisabled ? -1 : 0}
              >
                {linkLabel}
              </ExternalLink>
            </>
          )}
        </span>
      </label>
    </div>
  );
}

export default Checkbox;
